// This instance is created once when the module loads.
const globalSegmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });

// Checks if the string contains any UTF-16 surrogate pairs (emojis or complex characters)
const HAS_COMPLEX_CHARACTERS_REGEX = /[\uD800-\uDFFF]/;

/**
 * Safely truncates a string by the number of visible characters (graphemes).
 * Prevents broken UTF-16 surrogate pairs that cause URIError in analytics tools.
 *
 * @param str The input string to truncate
 * @param maxLength The maximum allowed length in visible characters
 * @returns The safely truncated string
 */
export function safeTruncate(str: string | null | undefined, maxLength: number): string {
  if (!str) return '';

  /** If raw length is within limits, it's already safe. */
  if (str.length <= maxLength) {
    return str;
  }

  // If the string has NO emojis or complex surrogate pairs,
  // we can safely use the native slice().
  if (!HAS_COMPLEX_CHARACTERS_REGEX.test(str)) {
    return str.slice(0, maxLength);
  }

  // Only run heavy segmentation if the string is long AND contains emojis.
  return [...globalSegmenter.segment(str)]
    .slice(0, maxLength)
    .map((s) => s.segment)
    .join('');
}
